import { useMemo } from 'react';
import { DistributionAccountDTO, useRmdDashboardQuery } from '../../api/useRmdDashboardQuery';
import { useRouteParams } from '../../hooks/useRouteParams';
import { SERIES_COLORS } from '../../../CommonComponents/OPL/charts/charts.constants';

interface ChartDataSeries extends DistributionAccountDTO {
  color: string;
}

export const useRmdDashboard = () => {
  const queryInfo = useRmdDashboardQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { isRegistrationGrouping, accounts } = queryInfo.data;

    const initialValue: { series: ChartDataSeries[]; categories: string[] } = {
      series: [],
      categories: [],
    };

    const chartData = accounts.reduce((acc, account, index) => {
      return {
        series: [
          ...acc.series,
          {
            ...account,
            color: SERIES_COLORS[index % SERIES_COLORS.length],
          },
        ],
        categories: [...acc.categories, account.name],
      };
    }, initialValue);

    return {
      isRegistrationGrouping,
      chartData,
    };
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
